var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column card is-offset-3 is-6 content has-text-centered"},[_c('div',{staticClass:"p-md"},[_c('h3',{domProps:{"textContent":_vm._s(_vm.$wording.register.activate_1)}}),_c('p',{domProps:{"textContent":_vm._s(_vm.$wording.register.activate_2)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }